import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export default function MarketingNav({ active }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Brand />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          <a href="/#features" className={active === "features" ? "text-foreground" : "text-muted-foreground hover:text-foreground transition-colors"} data-testid="nav-link-features">Features</a>
          <a href="/#industries" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-link-industries">Industries</a>
          <Link to="/pricing" className={active === "pricing" ? "text-foreground" : "text-muted-foreground hover:text-foreground transition-colors"} data-testid="nav-link-pricing">Pricing</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" className="text-sm font-medium px-4 py-2 hover:bg-secondary transition-colors" data-testid="nav-login-button">Sign in</Link>
          <Link to="/signup" className="text-sm font-semibold px-4 py-2 bg-primary text-primary-foreground hover:bg-accent transition-colors" data-testid="nav-signup-button">Start free</Link>
        </div>
      </div>
    </header>
  );
}
